const WASM_BASE =
  (process.env.VITE_WORD_CONNECT_WASM_BASE ?? '/wasm/word-connect').replace(/\/$/, '');

type WordConnectAesGcmDecryptFn = (
  packedBase64: string,
  keyBase64: string
) => Promise<string>;

interface WordConnectCryptoGlobal {
  __wordConnectAesGcmDecrypt?: WordConnectAesGcmDecryptFn;
}

function wordConnectCryptoGlobal(): WordConnectCryptoGlobal {
  return globalThis as WordConnectCryptoGlobal;
}

let cryptoHelperLoaded = false;

async function ensureWordConnectCryptoHelper(): Promise<void> {
  const g = wordConnectCryptoGlobal();
  if (cryptoHelperLoaded && g.__wordConnectAesGcmDecrypt) return;
  await import(/* webpackIgnore: true */ `${WASM_BASE}/word-connect-crypto.js`);
  if (!wordConnectCryptoGlobal().__wordConnectAesGcmDecrypt) {
    throw new Error('Word Connect crypto helper failed to load.');
  }
  cryptoHelperLoaded = true;
}

/** Decrypt server bootstrap cipher via Web Crypto (AES-GCM). Returns base64 plaintext for WASM. */
export async function decryptWordConnectBootstrapCipher(
  cipherBase64: string,
  keyBase64: string
): Promise<string> {
  await ensureWordConnectCryptoHelper();
  const decrypt = wordConnectCryptoGlobal().__wordConnectAesGcmDecrypt;
  if (!decrypt) {
    throw new Error('Word Connect crypto helper failed to load.');
  }
  return decrypt(cipherBase64, keyBase64);
}
